import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { WOStatusNo } from 'projects/Autofacets-Core/src/app/utils/enums';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalService } from '../../../helper/Services/global.service';
import { OrderStatusService } from '../../../Services/orderstatus/order-status.service';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';

@Component({
  selector: 'app-vehicle-status',
  templateUrl: './vehicle-status.component.html'
})
export class VehicleStatusComponent implements OnInit, OnDestroy {
  statusConfigData: any[];
  orderInfo: any = {};
  orderData: any;
  status: any[];
  statusCount: number;
  statusDegree: number;
  static counter: any = 0;
  count: number = 0;
  statusData: any = {};
  currentAppointment: any;
  orderServiceinfo: any;
  orderAdditionalinformation: any;
  orderAdditionalinfo: any;
  isAdditionalInformation = false;
  isAdditionalinfo = false;
  isServiceAvailable = false;
  timer = new Date().setMinutes(4, 59);
  statusInterval: any;
  cancelledStatusId: number = 5
  cancelledStatusStep: number = 4
  invoicePaid: number = 8
  isHideOrderStatus: boolean = false;
  private Unsub$ = new Subject<void>();

  constructor(
    private orderService: OrderStatusService,
    private spinner: NgxSpinnerService,
    private gService: GlobalService,
    private router: Router,
    private cdf: ChangeDetectorRef,
  ) {
    this.currentAppointment = this.gService.getAppInitialData;
  }

  ngOnInit(): void {
    if (this.orderService.isStatusSpinnerHide.observers) {
      this.orderService.isStatusSpinnerHide.asObservable().pipe(takeUntil(this.Unsub$))
        .subscribe(x => {
          this.isHideOrderStatus = x;
        });
    }

    this.onLoad();
  }

  /**
  * Purpose of the method to bind all controls from one place (which we need at the time of page load)
  * after that put this method to page init()
  */
  onLoad() {
    // get order info
    this.getData();
    if (this.currentAppointment) {
      if (+(EnvSetting.StatusTrackerInterval) > 0) {
        this.statusInterval = setInterval(() => {
          this.refreshOrderStatus()
        }, +(EnvSetting.StatusTrackerInterval));
      }
    } else {
      this.router.navigate(['/error-page']);
    }
  }
  getData() {
    this.spinner.show();
    this.orderService.GetConfiguredStatus().subscribe(statusData => {
      this.spinner.hide();
      this.orderService.isOrderSpinnerHide.next(true);
      if (statusData) {
        for (let i = 0; i < statusData.length; i++) {
          statusData[i].statusId = i;
          const obj = this.getIconAndClass(statusData[i].statusName);
          statusData[i].class = obj.class;
          statusData[i].iconClass = obj.iconClass;
          statusData[i].Key = obj.Key;
          // Add "total": 2 to all objects in array
        }
        this.statusConfigData = (statusData as []).slice();
        statusData = statusData.filter(x => x.id === 2 || x.id === 3 || x.id === 6 || x.id === 7 || x.id === 10)
        this.status = statusData;
        this.statusCount = this.status.length;
        this.statusDegree = 360 / this.statusCount;
      }
      this.orderService.orderDetails.subscribe(res => {
        if (!isNullOrUndefined(res)) {
          this.orderInfo = this.orderDetailsDataMapper(res);
        }
      });
    });
  }

  private orderDetailsDataMapper(orderInfo: any) {
    if (orderInfo) {
      const single = Object();
      single.vbrand = orderInfo.vehileBrand ? this.gService.getBrandLogo(orderInfo.vehileBrand) : null;
      single.vModal = orderInfo.vehicleModel;
      single.ordernumber = this.currentAppointment.repairId;
      single.customerName = orderInfo.customerName;
      single.dealerName = orderInfo.dealerName;
      single.dealerId = orderInfo.dealerId;
      single.telephone = orderInfo.landlineNumber;
      single.mobile = orderInfo.mobileNumber;
      single.openingHours = orderInfo.openingHours;
      this.orderService.repairActualStatusId.subscribe(resStatusId => {
        if (resStatusId === Enums.WOStatus.OnHold) {
          single.isOnHold = true;
          this.orderService.previousStatusId.subscribe(statusId => {
            single.actualRepairStatus = statusId;
            single.cState = this.getOrderStatus(statusId);
          });
        }
        else {
          single.actualRepairStatus = resStatusId;
          single.cState = this.getOrderStatus(resStatusId);
        }
      });
      return single;
    }
  }


  getIconAndClass(oldStatus: string): { class: string, iconClass: string, Key: string } {
    const obj: { class: string, iconClass: string, Key: string } = { class: undefined, iconClass: undefined, Key: undefined };
    switch (oldStatus) {
      case 'Closed':
      case 'Invoice Paid':
        obj.class = 'readytodeliver'
        obj.iconClass = 'ready-deliver'
        obj.Key = 'lblReadyforcollection'
        break;
      case 'WORKSTARTED':
        obj.class = 'icn-inprod-status'
        obj.iconClass = 'icn-inprod'
        break;
      case 'Car arrived':
        obj.class = 'icn-inorder-status'
        obj.iconClass = 'icn-inorder'
        obj.Key = 'lblVehicleArrived'
        break;
      case 'Mechanic started':
      case 'Mechanic done':
        obj.class = 'icn-onway-status'
        obj.iconClass = 'icn-onway'
        obj.Key = 'lblWorkinProgress'
        break;
      case 'Work done':
        obj.class = 'work-done-status'
        obj.iconClass = 'work-done'
        obj.Key = 'lblWorkDone'
        break;
      case 'Invoice ready':
        obj.class = 'paymenetconfirm'
        obj.iconClass = 'payment-confirm'
        obj.Key = 'lblInvoiceReady'
        break;
    }
    return obj;
  }

  getIconClass(code: number): string {
    let icon = undefined;
    this.status.forEach(element => {
      if (element.id === code) {
        icon = element.class;
      }
    });
    return icon ?? 'work-done-green';
  }

  applyStepComplete(): number {
    if (this.orderInfo.cState)
      return this.orderInfo.cState.step === this.cancelledStatusStep ? 0 : this.orderInfo.cState.step;
  }

  circleRotateStyle(index: any): string {
    const degree = (+index) * this.statusDegree;
    return 'rotate(' + degree + 'deg)';
  }

  isStepCompleted(status: any) {
    const step = +(status.step as string).slice(4);
    let currentStep;
    if (this.orderInfo.cState)
      currentStep = this.orderInfo.cState.step;
    if ((currentStep === WOStatusNo.WorkRequest) || (currentStep === WOStatusNo.Prepared) || (currentStep === WOStatusNo.Waitingforcustomer) || (currentStep === WOStatusNo.Cancelled)) {
      return false;
    }
    if (this.orderInfo.cState !== undefined && status.statusId === this.invoicePaid && this.orderInfo.cState.step === WOStatusNo.InvoicePaid) {
      return true;
    }
    else {
      return step <= currentStep;
    }
  }

  arrowPosition(): string {
    let statusCount, statusId, currentStepNumber;
    if (this.status) {
      statusCount = this.status.length;
    }
    const diff = 360 / statusCount;
    const startDegree = -45;
    if (this.orderInfo.cState) {
      statusId = this.orderInfo.cState.code;
      if (this.statusConfigData) {
        currentStepNumber = this.statusConfigData.findIndex(x => x.id === statusId);
      }
    }
    if (currentStepNumber === 0 || currentStepNumber === this.cancelledStatusStep) {
      return 'rotate(' + startDegree + 'deg)';
    }
    const degree = startDegree + (diff * (currentStepNumber > this.cancelledStatusStep ? currentStepNumber - 1 : currentStepNumber)) - (diff / 2);
    return 'rotate(' + degree + 'deg)';
  }

  getOrderStatus(statusCode: number): { code: number, text: string, step: number } {
    const obj: { code: number, text: string, step: number } = { code: undefined, text: undefined, step: undefined };
    while (true) {
      this.statusConfigData.forEach(element => {
        if (element.id === statusCode) {
          obj.code = element.id;
          obj.text = element.statusName;
          obj.step = +(element.step as string).slice(4);
        }
      });
      if (obj.code !== undefined) {
        break;
      }
      statusCode = statusCode - 1;
      if (statusCode === 0) {
        break;
      }
    }
    return obj;
  }

  private refreshOrderStatus() {
    this.spinner.show();
    this.orderService.getOrderStatusDetails().then(res => {
      if (res) {
        if (res.repairStatusDetails == null) {
          this.count = this.count + 1;
          if (this.count == 5) {
            clearInterval(this.statusInterval);
          }
        }
        this.orderService.repairActualStatusId.subscribe(resStatusId => {
          this.orderInfo.actualRepairStatus = resStatusId;
          this.orderInfo.cState = this.getOrderStatus(resStatusId);
          this.cdf.detectChanges();
        }).unsubscribe();
      }
    }).finally(() => {
      this.spinner.hide();
    });
  }

  ngOnDestroy(): void {
    clearInterval(this.statusInterval);
    this.Unsub$.next();
    this.Unsub$.complete();
  }
}
